<div class=" header bg-gradient-nhc-orange pb-6">
  <div class=" container-fluid">
    <div class=" header-body">
      <div class=" row align-items-center py-4">
        <div class=" col-lg-6 col-7">
          <nav
            aria-label="breadcrumb"
            class=" d-none d-md-inline-block ml-md-4"
          >
            <ol class=" breadcrumb breadcrumb-links breadcrumb-dark">
              <li class=" breadcrumb-item">
                <a [routerLink]="['/']" href="javascript:void(0)">
                  <i class=" fas fa-home"></i>
                </a>
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
<div class=" container-fluid mt--4">
  <form (ngSubmit)="submitRegistrationForm()" [formGroup]="organizationForm">
    <div class=" row">
      <div class=" col-lg">
        <div class=" card-wrapper">
          <div formGroupName="organizeInfo">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-md-9 col-lg-9 col-sm-12">
                    <h3 class=" mb-0">New Partner Organization</h3>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="p-2 mb-2">
                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Legal Name
                        </label>
                        <div class="col-md-9">
                          <input class="form-control" formControlName="name"
                                 id="name" type="text">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Street Name
                        </label>
                        <div class="col-md-9">
                          <input [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.addressStreet')?.invalid
                               && organizationForm.get('organizeInfo.addressStreet')?.touched }"
                                 class="form-control"
                                 formControlName="addressStreet"
                                 id="streetNameInput"
                                 type="text"
                                 [maxlength]="accountTextLimits.addressStreet">
                          <div
                            *ngIf="organizationForm.get('organizeInfo.addressStreet')?.invalid     && organizationForm.get('organizeInfo.addressStreet')?.touched"
                            class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.addressStreet')?.hasError('required')">
                              Street Name is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.addressStreet')?.hasError('maxlength')">
                              Street Name cannot
                              exceed {{ organizationForm.get('organizeInfo.addressStreet')?.errors?.maxlength.requiredLength }}
                              characters.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          City
                        </label>
                        <div class="col-md-9">
                          <input [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.addressCity')?.invalid
                               && organizationForm.get('organizeInfo.addressCity')?.touched }" class="form-control"
                                 formControlName="addressCity"
                                 id="cityInput" type="text"
                                 [maxlength]="accountTextLimits.addressCity">
                          <div
                            *ngIf="organizationForm.get('organizeInfo.addressCity')?.invalid     && organizationForm.get('organizeInfo.addressCity')?.touched"
                            class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.addressCity')?.hasError('required')">
                              City is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.addressCity')?.hasError('maxlength')">
                              City cannot
                              exceed {{ organizationForm.get('organizeInfo.addressCity')?.errors?.maxlength.requiredLength }}
                              characters.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Postal Code
                        </label>
                        <div class="col-md-9">
                          <input [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.addressPostal')?.invalid
                               && organizationForm.get('organizeInfo.addressPostal')?.touched }" class="form-control"
                                 formControlName="addressPostal"
                                 id="PostalCodeInput" type="text"
                                 [maxlength]="accountTextLimits.addressPostal">
                          <div
                            *ngIf="organizationForm.get('organizeInfo.addressPostal')?.invalid     && organizationForm.get('organizeInfo.addressPostal')?.touched"
                            class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.addressPostal')?.hasError('required')">
                              Postal Code is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.addressPostal')?.hasError('maxlength')">
                              Postal Code cannot
                              exceed {{ organizationForm.get('organizeInfo.addressPostal')?.errors?.maxlength.requiredLength }}
                              characters.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Country
                        </label>
                        <div class="col-md-9">
                          <!--input [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.addressCountry')?.invalid
                               && organizationForm.get('organizeInfo.addressCountry')?.touched }" class="form-control"
                                 formControlName="addressCountry"
                                 id="countryInput" type="text"-->
                          <select [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.addressCountry')?.invalid
                               && organizationForm.get('organizeInfo.addressCountry')?.touched }"
                                  class="form-control"
                                  formControlName="addressCountry" id="countiesDdl" name="cars">
                            <option *ngFor="let value of counties" [value]="value.id">{{ value.name }}</option>

                          </select>
                          <div
                            *ngIf="organizationForm.get('organizeInfo.addressCountry')?.invalid     && organizationForm.get('organizeInfo.addressCountry')?.touched"
                            class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.addressCountry')?.hasError('required')">
                              Country is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.addressCountry')?.hasError('maxlength')">
                              Country cannot
                              exceed {{ organizationForm.get('organizeInfo.addressCountry')?.errors?.maxlength.requiredLength }}
                              characters.
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">Email</label>
                        <div class="col-md-9">
                          <input
                            [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.email')?.invalid
                               && organizationForm.get('organizeInfo.email')?.touched }"
                            class="form-control"
                            formControlName="email" type="email">
                          <div
                            *ngIf="organizationForm.get('organizeInfo.email')?.invalid     && organizationForm.get('organizeInfo.email')?.touched"
                            class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.email')?.hasError('required')">
                              Email is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.email')?.hasError('maxlength')">
                              Email cannot
                              exceed {{ organizationForm.get('organizeInfo.email')?.errors?.maxlength.requiredLength }}
                              characters.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Approximate Annual Budget
                        </label>
                        <div class="col-md-3">
                          <input [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.annualBudget')?.invalid
                               && organizationForm.get('organizeInfo.annualBudget')?.touched }" class="form-control"
                                 formControlName="annualBudget"
                                 id="aabInput" placeholder="0" type="number" step="1"
                                 [min]="accountLimits.annualBudget.min" [max]="accountLimits.annualBudget.max">
                          <div
                            *ngIf="organizationForm.get('organizeInfo.annualBudget')?.invalid && organizationForm.get('organizeInfo.annualBudget')?.touched"
                            class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.annualBudget')?.hasError('required')">
                              Approximate Annual Budget is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.annualBudget')?.hasError('wholeNumber')">
                              Please enter a whole number (no decimals).
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.annualBudget')?.hasError('min')">
                              Approximate Annual Budget cannot be negative.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.annualBudget')?.hasError('max')">
                              Approximate Annual Budget cannot exceed {{ accountLimits.annualBudget.max | number }}.
                            </div>
                          </div>

                        </div>
                        <label class="col-md-2 col-form-label form-control-label">
                          Currency
                        </label>
                        <div class="col-md-4">
                          <select [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.currencyId')?.invalid
                               && organizationForm.get('organizeInfo.currencyId')?.touched }"
                                  class="form-control"
                                  formControlName="currencyId" id="currencyDdl" name="cars">
                            <option *ngFor="let value of currency" [value]="value.id">{{ value.name }}</option>

                          </select>
                          <div
                            *ngIf="organizationForm.get('organizeInfo.currencyId')?.invalid     && organizationForm.get('organizeInfo.currencyId')?.touched"
                            class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.currencyId')?.hasError('required')">
                              Currency is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.currencyId')?.hasError('maxlength')">
                              Currency cannot
                              exceed {{ organizationForm.get('organizeInfo.currencyId')?.errors?.['maxlength'].requiredLength }}
                              characters.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.currencyId')?.hasError('pattern')">
                              Currency must use Latin characters only.
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Website <span class="text-muted small">(optional)</span>
                        </label>
                        <div class="col-md-9">
                          <input [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.webSiteUrl')?.invalid
                               && organizationForm.get('organizeInfo.webSiteUrl')?.touched }"
                                 class="form-control"
                                 formControlName="webSiteUrl"
                                 id="websiteInput" type="text"
                                 [maxlength]="accountTextLimits.webSiteUrl">
                          <div
                            *ngIf="organizationForm.get('organizeInfo.webSiteUrl')?.invalid     && organizationForm.get('organizeInfo.webSiteUrl')?.touched"
                            class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.webSiteUrl')?.hasError('required')">
                              Website is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.webSiteUrl')?.hasError('maxlength')">
                              Website cannot
                              exceed {{ organizationForm.get('organizeInfo.webSiteUrl')?.errors?.maxlength.requiredLength }}
                              characters.
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Number of Staff
                        </label>
                        <div class="col-md-9">
                          <input [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.numberOfEmployees')?.invalid
                               && organizationForm.get('organizeInfo.numberOfEmployees')?.touched }"
                                 class="form-control"
                                 formControlName="numberOfEmployees"
                                 id="numberOfStaffInput" type="number" step="1"
                                 [min]="accountLimits.numberOfEmployees.min" [max]="accountLimits.numberOfEmployees.max">

                          <div
                            *ngIf="organizationForm.get('organizeInfo.numberOfEmployees')?.invalid && organizationForm.get('organizeInfo.numberOfEmployees')?.touched"
                            class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfEmployees')?.hasError('required')">
                              Number of Staff is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfEmployees')?.hasError('wholeNumber')">
                              Please enter a whole number (no decimals).
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfEmployees')?.hasError('min')">
                              Number of Staff cannot be negative.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfEmployees')?.hasError('max')">
                              Number of Staff cannot exceed {{ accountLimits.numberOfEmployees.max | number }}.
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Phone
                        </label>
                        <div class="col-md-9">
                          <input [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.phone')?.invalid
                               && organizationForm.get('organizeInfo.phone')?.touched }" class="form-control"
                                 formControlName="phone"
                                 id="phoneInput" type="tel"
                                 [maxlength]="accountTextLimits.phone">
                          <div
                            *ngIf="organizationForm.get('organizeInfo.phone')?.invalid     && organizationForm.get('organizeInfo.phone')?.touched"
                            class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.phone')?.hasError('required')">
                              Phone is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.phone')?.hasError('maxlength')">
                              Phone cannot
                              exceed {{ organizationForm.get('organizeInfo.phone')?.errors?.maxlength.requiredLength }}
                              characters.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Number of Volunteers
                        </label>
                        <div class="col-md-9">
                          <input [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.numberOfVoulenteers')?.invalid
                               && organizationForm.get('organizeInfo.numberOfVoulenteers')?.touched }"
                                 class="form-control"
                                 formControlName="numberOfVoulenteers"
                                 id="dd" type="number" step="1"
                                 [min]="accountLimits.numberOfVoulenteers.min" [max]="accountLimits.numberOfVoulenteers.max">
                          <div
                            *ngIf="organizationForm.get('organizeInfo.numberOfVoulenteers')?.invalid && organizationForm.get('organizeInfo.numberOfVoulenteers')?.touched"
                            class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfVoulenteers')?.hasError('required')">
                              Number of Volunteers is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfVoulenteers')?.hasError('wholeNumber')">
                              Please enter a whole number (no decimals).
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfVoulenteers')?.hasError('min')">
                              Number of Volunteers cannot be negative.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfVoulenteers')?.hasError('max')">
                              Number of Volunteers cannot exceed {{ accountLimits.numberOfVoulenteers.max | number }}.
                            </div>
                            <div
                              *ngIf="organizationForm.get('organizeInfo.numberOfVoulenteers')?.errors?.min as minError"
                            >
                              Minimum volunteers is {{ minError.min }}.
                            </div>
                            <div
                              *ngIf="organizationForm.get('organizeInfo.numberOfVoulenteers')?.errors?.max as maxError"
                            >
                              Maximum volunteers is {{ maxError.max }}.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Industry
                        </label>
                        <div class="col-md-9">
                          <select class="form-control"
                                  [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.industry')?.invalid
                               && organizationForm.get('organizeInfo.industry')?.touched }"
                                  name="industry" id="industry" formControlName="industry">
                            <option *ngFor="let value of industries" [value]="value.id">{{value.name}}</option>

                          </select>
                          <div  class="invalid-feedback" >
                            Industry is required.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <app-assesement-upload
                    [data]="files"
                    [documentDatas]="documentDatas"
                    [parentForm]="fileForm"
                  >
                  </app-assesement-upload>






                  <div>
                    <label class="form-control-label">Main Aims</label>
                    <textarea [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.description')?.invalid
                               && organizationForm.get('organizeInfo.description')?.touched }"
                              class="form-control"
                              formControlName="description" id="mainAimsInput" rows="7">
                  </textarea>
                    <app-char-counter [control]="organizationForm.get('organizeInfo.description')"
                                      [max]="accountTextLimits.description"></app-char-counter>
                    <div
                      *ngIf="organizationForm.get('organizeInfo.description')?.invalid && organizationForm.get('organizeInfo.description')?.touched"
                      class="invalid-feedback">
                      <div *ngIf="organizationForm.get('organizeInfo.description')?.hasError('required')">
                        Main Aims is required.
                      </div>
                      <div *ngIf="organizationForm.get('organizeInfo.description')?.hasError('maxlength')">
                        Main Aims cannot exceed {{ organizationForm.get('organizeInfo.description')?.errors?.maxlength.requiredLength }} characters.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div formArrayName="contactInfo">
          <div *ngFor="let contactGroup of contactInfoFormArray.controls; let i = index" [formGroupName]="i"
               class="card">
            <div class="card-header d-flex justify-content-between">
              <span>Contact {{ i + 1 }}</span>
              <button *ngIf="i > 0" (click)="removeContact(i)" class="btn btn-danger btn-sm" type="button">Remove</button>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-lg-6 col-sm-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label form-control-label">First Name</label>
                    <div class="col-md-9">
                      <input
                        [ngClass]="{ 'is-invalid': contactGroup.get('firstName')?.invalid && contactGroup.get('firstName')?.touched }"
                        class="form-control"
                        formControlName="firstName" type="text">
                      <div
                        *ngIf="contactGroup.get('firstName')?.invalid     && contactGroup.get('firstName')?.touched"
                        class="invalid-feedback">
                        <div *ngIf="contactGroup.get('firstName')?.hasError('required')">
                          First Name is required.
                        </div>
                        <div *ngIf="contactGroup.get('firstName')?.hasError('maxlength')">
                          First Name cannot
                          exceed {{ contactGroup.get('firstName')?.errors?.maxlength.requiredLength }}
                          characters.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label form-control-label">Last Name</label>
                    <div class="col-md-9">
                      <input
                        [ngClass]="{ 'is-invalid': contactGroup.get('lastName')?.invalid && contactGroup.get('lastName')?.touched }"
                        class="form-control"
                        formControlName="lastName"
                        type="text">
                      <div
                        *ngIf="contactGroup.get('lastName')?.invalid     && contactGroup.get('lastName')?.touched"
                        class="invalid-feedback">
                        <div *ngIf="contactGroup.get('lastName')?.hasError('required')">
                          Last Name is required.
                        </div>
                        <div *ngIf="contactGroup.get('lastName')?.hasError('maxlength')">
                          Last Name cannot
                          exceed {{ contactGroup.get('lastName')?.errors?.maxlength.requiredLength }}
                          characters.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-lg-6 col-sm-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label form-control-label">Position</label>
                    <div class="col-md-9">
                      <input
                        [ngClass]="{ 'is-invalid': contactGroup.get('position')?.invalid && contactGroup.get('position')?.touched }"
                        class="form-control"
                        formControlName="position"
                        type="text">
                      <div
                        *ngIf="contactGroup.get('position')?.invalid     && contactGroup.get('position')?.touched"
                        class="invalid-feedback">
                        <div *ngIf="contactGroup.get('position')?.hasError('required')">
                          Position is required.
                        </div>
                        <div *ngIf="contactGroup.get('position')?.hasError('maxlength')">
                          Position cannot
                          exceed {{ contactGroup.get('position')?.errors?.maxlength.requiredLength }}
                          characters.
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label form-control-label">Email</label>
                    <div class="col-md-9">
                      <input
                        class="form-control"
                        [ngClass]="{ 'is-invalid': contactGroup.get('email')?.invalid && contactGroup.get('email')?.touched }"
                        formControlName="email" type="email">
                      <div
                        *ngIf="contactGroup.get('email')?.invalid     && contactGroup.get('email')?.touched"
                        class="invalid-feedback">
                        <div *ngIf="contactGroup.get('email')?.hasError('required')">
                          Email is required.
                        </div>
                        <div *ngIf="contactGroup.get('email')?.hasError('maxlength')">
                          Email cannot
                          exceed {{ contactGroup.get('email')?.errors?.maxlength.requiredLength }}
                          characters.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-lg-6 col-sm-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label form-control-label">Phone</label>
                    <div class="col-md-9">
                      <input
                        [ngClass]="{ 'is-invalid': contactGroup.get('phone')?.invalid && contactGroup.get('phone')?.touched }"
                        class="form-control"
                        formControlName="phone" type="tel">
                      <div
                        *ngIf="contactGroup.get('phone')?.invalid     && contactGroup.get('phone')?.touched"
                        class="invalid-feedback">
                        <div *ngIf="contactGroup.get('phone')?.hasError('required')">
                          Phone is required.
                        </div>
                        <div *ngIf="contactGroup.get('phone')?.hasError('maxlength')">
                          Phone cannot
                          exceed {{ contactGroup.get('phone')?.errors?.maxlength.requiredLength }}
                          characters.
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label form-control-label">Preferred Method of Contact</label>
                    <div class="col-md-9">
                      <select
                        [ngClass]="{ 'is-invalid': contactGroup.get('contactMethodId')?.invalid && contactGroup.get('contactMethodId')?.touched }"
                        class="form-control"
                        formControlName="contactMethodId">
                        <option *ngFor="let method of contactMethods"

                                [value]="method.id">
                          {{ method.name }}
                        </option>

                      </select>
                      <div class="invalid-feedback">
                        Preferred Method of Contact is required.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="mb-4">
            <button (click)="addContact()" class="btn btn-primary" type="button">
              Add an Additional Contact
            </button>
          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <button class="btn btn-primary" type="submit">Submit</button>
            <button [routerLink]="['/registration']" class="btn btn-secondary" type="button">Back</button>
          </div>
        </div>
      </div>
    </div>
  </form>

</div>
